module.exports = "/images/history.svg?5d56996c71ef56154f10755d59c2cb40";